Object.defineProperty(exports, "__esModule", {
  value: true
});

function RangeQuery(key, options) {
  var _a;

  return {
    range: (_a = {}, _a[key] = options, _a)
  };
}

exports.RangeQuery = RangeQuery;